



























import { computed, defineComponent, ref } from '@nuxtjs/composition-api'
import { useCart } from '~/composables';
import useTemporizedCart from '~/composables/useTemporizedCart';
import CartItem from '../MiniCart/Item.vue';
import AddToCart from '~/components/solepro/AddToCart.vue';
import useLoader from '~/composables/useLoader';
import { cartProductRemoveLink } from '~/helpers/trackings/24orepro/cart';


export default defineComponent({
    props: {
        item: {
            required: true,
            type: Object //@TODO define type
        }
    },
    data() {
        return {
            sprite: require('~/assets/solepro/spritemap.svg')
        }
    },
    components:{
        CartItem,
        AddToCart
    },
    setup(props) {
        const {item} = props;
        const { updateItemQty, removeItem, load: loadCart, cart } = useCart();
        const  { addDeletedProduct, removeDeletedProduct, deletedProducts } = useTemporizedCart();
        const { setIsLoading} = useLoader();        
        const productConfiguration = computed(()=>{
            if(item.configurable_options && item.configurable_options.length>0){
                let configurableOptions = {};
                item.configurable_options.forEach(opt=>{
                    configurableOptions[opt.configurable_product_option_uid] = opt.configurable_product_option_value_uid;
                })
                return Object.keys(configurableOptions).length>0 ? {[item.product.sku] : configurableOptions}:null
            }
            return null;
        })
        const isDeleted = computed(()=>{
            return deletedProducts.value.find(el=>el.uid==item.uid) || !cart.value.items.map(el=>el.uid).includes(item.uid)
        })
        
        return {
            updateItemQty,
            removeItem,
            addDeletedProduct,
            removeDeletedProduct,
            productConfiguration,
            loadCart,
            setIsLoading,
            isDeleted,
            deletedProducts
        }
    },
    methods: {
        async updateQty(item, qty) {
            this.setIsLoading(true)
            /** posso aggiungere se ho meno di 10 a carrello di quel prodotto
             * posso rimuovere se ho almeno 2 a carrello di quel prodotto
             */
            if ((qty > 0 && item.quantity < 10) || (qty < 0 && item.quantity > 1)) {
                await this.updateItemQty({ product: item, quantity: item.quantity + qty });

            } else if (qty < 0 && item.quantity == 1) {
                await this.removeItem({ product: item });

            }
            this.setIsLoading(false)
            
        },
        async reloadCart (){
            await this.loadCart({ realCart: true });
            this.setIsLoading(false)
        },
        async temporizedRemove(item){
            /** 
             * Track Intention: No need to wait because a product can be restored.
            */

            cartProductRemoveLink(item)

            this.setIsLoading(true)
            await this.removeItem({ product: item });
            item.timeout = setTimeout(()=>{
                item.hide=true;
                this.removeDeletedProduct(item);
            },15000)
            this.addDeletedProduct(item)
            console.log("Setting",item.timeout)
            this.setIsLoading(false)
        },
        cancelDelete(item){
            const t = this.deletedProducts.find(el=>el.uid==item.uid).timeout
            this.setIsLoading(true)
            console.log("Setting off",t)
            item.timeout=null;
            clearTimeout(t)
            this.removeDeletedProduct(item);
        }
    }
})
